import { Experiences } from '@/src/experiences'

export default Experiences.PointsToStatementCredit.Navigation.Layout
